/**
 * One bed-diameter range that a Model (machine) supports. Backed by the
 * `model_diameter_range` table; a machine can have N rows (e.g. interchangeable
 * collet sets or feeders). Consumed by the planner DiameterCoincidenceScorer.
 */
export class ModelDiameterRange {
  constructor(
    public hash?: string,
    public label?: string,
    public minDiameterMm?: number,
    public maxDiameterMm?: number,
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/model-diameter-range.ts